module.exports = __webpack_public_path__ + "static/media/plane(15).ef6fef04.PNG";